// Grand Gather Registry — Web Push Notifications
// Handles push subscription lifecycle: subscribe on login, unsubscribe on logout

import api from '../api';

export async function subscribeToPush() {
  try {
    if (!('Notification' in window) || !('serviceWorker' in navigator)) return;

    // Only prompt if permission is still "default" (never asked).
    // On installed Android PWAs, permission comes back "granted" immediately
    // without showing a dialog — matching WhatsApp/Facebook behaviour.
    let permission = Notification.permission;
    if (permission === 'denied') return;
    if (permission === 'default') {
      permission = await Notification.requestPermission();
    }
    if (permission !== 'granted') return;

    const registration = await navigator.serviceWorker.ready;
    const { data } = await api.get('/config/public');

    // Always unsubscribe the old subscription first — after a SW update the old
    // endpoint returns 410 from FCM, so we must create a fresh one every time.
    let subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      await subscription.unsubscribe();
    }
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlB64ToUint8Array(data.vapidPublicKey),
    });

    await api.post('/notifications/subscribe', { subscription: subscription.toJSON() });
  } catch (e) {
    // Fail silently — in-app notifications still work
  }
}

export async function unsubscribeFromPush() {
  try {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    if (subscription) {
      await api.post('/notifications/unsubscribe', { subscription: subscription.toJSON() });
      await subscription.unsubscribe();
    }
  } catch (e) {
    // Fail silently
  }
}

function urlB64ToUint8Array(base64String) {
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, '+').replace(/_/g, '/');
  const rawData = window.atob(base64);
  return new Uint8Array([...rawData].map(c => c.charCodeAt(0)));
}
